export default __webpack_public_path__ + "static/media/CarImages.PRunnerMedium2.9e0d5fb3.jpg";